import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import {
  Box,
  Typography,
  Stack,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
} from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import TodayIcon from '@mui/icons-material/Today';
import Breadcrumb from './BreadCrump';

import TopNav from './Navbar';
import LeftNavbar from './LeftNav';

const Calendar = () => {
  const [events, setEvents] = useState([]);
  const [selected, setSelected] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [currentTitle, setCurrentTitle] = useState('');
  const calendarRef = useRef(null);

  // Fetch events from backend
  useEffect(() => {
    axios
      .get('http://196.216.9.34:5020/api/events') // <-- Replace with your actual backend URL in production
      .then((res) => {
        setEvents(res.data);
      })
      .catch((err) => {
        console.error('Failed to fetch events:', err);
      });
  }, []);

  const handleEventClick = (clickInfo) => {
    const eventId = clickInfo.event.id;
    const ev = events.find((e) => e.id.toString() === eventId);
    if (ev) {
      setSelected(ev);
      setDialogOpen(true);
    }
  };

  const goPrev = () => {
    calendarRef.current.getApi().prev();
    updateTitle();
  };

  const goNext = () => {
    calendarRef.current.getApi().next();
    updateTitle();
  };

  const goToday = () => {
    calendarRef.current.getApi().today();
    updateTitle();
  };

  const updateTitle = () => {
    const api = calendarRef.current?.getApi();
    if (api) {
      setCurrentTitle(api.view.title);
    }
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <LeftNavbar />
      <Box sx={{ flexGrow: 1, ml: { lg: '240px' } }}>
        <TopNav />
        <Box sx={{ p: 10, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
          <Breadcrumb currentPage="Calendar" />

          <Stack
            style={{ backgroundColor: 'white' }}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography
              variant="h5"
              sx={{
                display: 'flex',
                alignItems: 'center',
                color: '#ff6600',
                fontWeight: 'bold',
              }}
            >
              <TodayIcon sx={{ mr: 1 }} /> {currentTitle}
            </Typography>
            <Stack direction="row" spacing={1} alignItems="center">
              <IconButton onClick={goPrev}>
                <ArrowBackIosNewIcon />
              </IconButton>
              <IconButton onClick={goToday}>
                <Typography variant="button">Today</Typography>
              </IconButton>
              <IconButton onClick={goNext}>
                <ArrowForwardIosIcon />
              </IconButton>
            </Stack>
          </Stack>

          <Box style={{ backgroundColor: 'white' }} sx={{ width: '70%', mx: 'auto' }}>
            <FullCalendar
              ref={calendarRef}
              plugins={[dayGridPlugin, interactionPlugin]}
              initialView="dayGridMonth"
              headerToolbar={false}
              events={events.map((e) => ({
                id: String(e.id),
                title: e.title,
                date: e.date,
              }))}
              eventClick={handleEventClick}
              firstDay={0}
              dayMaxEventRows={3}
              height="auto"
              datesSet={(arg) => setCurrentTitle(arg.view.title)}
            />
          </Box>

          <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
            <DialogTitle>{selected?.title}</DialogTitle>
            <DialogContent>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Date:</strong> {selected?.date}
              </Typography>
              <Typography variant="body2">
                <strong>Details:</strong> {selected?.description}
              </Typography>
            </DialogContent>
          </Dialog>
        </Box>
      </Box>
    </Box>
  );
};

export default Calendar;
